import axios from "axios";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import Loader from "../../components/Loader";
import Modal from "../../components/Modal/Modal";
import useAuth from "../../hooks/useAuth";
import { BASE_URL } from "../../utils/Element";
import AddUnderContractData from "./components/AddUnderContractData";

const initialData = {
  executed_id: "",
  property: { id: "", name: "" },
  company_gcl: "",
  contract_price: "",
  contract_cap_rate: "",
  created_at: "",
  contract_date: "",
  gcl_broker_representing_seller: "",
  gcl_broker_representing_buyer: "",
  gcl_bds_seller: "",
  gcl_bds_buyer: "",
};

const EditUnderContractModal = ({ showModal, onClose, onCallApi, id }) => {
  const [config] = useAuth();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false);
  const [addexecutedData, setExecutedData] = useState(initialData);
  const [isDollar, setIsDollar] = useState(false)
  const [isSellerBDSDollar, setIsSellerBDSDollar] = useState(false)
  const [isBuyerBDSDollar, setIsBuyerBDSDollar] = useState(false)
  const [isSellerBrokerDollar, setIsSellerBrokerDollar] = useState(false)
  const [isBuyerBrokerDollar, setIsBuyerBrokerDollar] = useState(false)

  useEffect(() => {
    if (id && showModal) {
      setLoading(true);
      axios
        .get(`${BASE_URL}/contract-getby-Id/${id}`, config)
        .then((res) => {
          const data = res?.data?.contract;
          setExecutedData({
            executed_id: data.executed_id,
            portfolio: data?.portfolio === 1 ? 1 : 0,
            property: {
              id: data?.executed?.link?.id,
              name: data?.executed?.link?.property_name,
            },
            company_gcl: data?.executed?.company_gcl,
            contract_price: data?.contract_price,
            contract_cap_rate: data?.contract_cap_rate,
            contract_date: data.created_at,
            gcl_broker_representing_seller: data?.gcl_broker_representing_seller,
            gcl_broker_representing_buyer: data?.gcl_broker_representing_buyer,
            gcl_bds_seller: data?.gcl_bds_seller,
            gcl_bds_buyer: data?.gcl_bds_buyer,
            company_gcl_type: data ? "dollar" : "percent",
            seller_bds_type: data ? "dollar" : "percent",
            buyer_bds_type: data ? "dollar" : "percent",
            seller_broker_type: data ? "dollar" : "percent",
            buyer_broker_type: data ? "dollar" : "percent",

          });
        })
        .catch((err) => {
          if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
            NotificationManager.error(err.response?.data?.message);
          }
        })
        .finally(() => setLoading(false));
    }
  }, [id, showModal]);

  const handleClose = () => {
    setExecutedData(initialData);
    onClose();
    setError();
    setDisable(false);
  };


  const handleChange = (value, name) => {
    setError({ ...error, [name]: "" });
    setExecutedData({ ...addexecutedData, [name]: value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setDisable(true);
    const dataToSend = {
      executed_id: addexecutedData.executed_id,
      portfolio: addexecutedData?.portfolio === 1 ? 1 : 0,
      property: addexecutedData.property,
      company_gcl: addexecutedData.company_gcl,
      contract_price: addexecutedData.contract_price,
      contract_cap_rate: addexecutedData.contract_cap_rate,
      contract_date: addexecutedData.contract_date,
      gcl_broker_representing_seller: addexecutedData.gcl_broker_representing_seller,
      gcl_broker_representing_buyer: addexecutedData.gcl_broker_representing_buyer,
      gcl_bds_seller: addexecutedData.gcl_bds_seller,
      gcl_bds_buyer: addexecutedData.gcl_bds_buyer,
      company_gcl_type: isDollar ? "dollar" : "percent",
      seller_bds_type: isSellerBDSDollar ? "dollar" : "percent",
      buyer_bds_type: isBuyerBDSDollar ? "dollar" : "percent",
      seller_broker_type: isSellerBrokerDollar ? "dollar" : "percent",
      buyer_broker_type: isBuyerBrokerDollar ? "dollar" : "percent",
    };

    axios
      .post(`${BASE_URL}/update-contract/${id}`, dataToSend, config)
      .then((res) => {
        handleClose();
        onCallApi();
      })
      .catch((err) => {
        setError(err.response?.data?.errors);
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => setDisable(false));
  };

  return (
    <Modal title={`Edit Under Contract`} desc={`Edit the Under Contract information.`} show={showModal} onClose={onClose}>
      {loading ? (
        <Loader />
      ) : (
        <AddUnderContractData
          addexecutedData={addexecutedData}
          setExecutedData={setExecutedData}
          handleChange={handleChange}
          error={error}
          onsetExecutedData={(value) => setExecutedData(value)}
          onSetError={(value) => setError(value)}
          handleSubmit={handleSubmit}
          handleClose={handleClose}
          showModal={showModal}
          disable={disable}
          isDollar={isDollar}
          setIsDollar={setIsDollar}
          isSellerBDSDollar={isSellerBDSDollar}
          setIsSellerBDSDollar={setIsSellerBDSDollar}
          isBuyerBDSDollar={isBuyerBDSDollar}
          setIsBuyerBDSDollar={setIsBuyerBDSDollar}
          isSellerBrokerDollar={isSellerBrokerDollar}
          setIsSellerBrokerDollar={setIsSellerBrokerDollar}
          isBuyerBrokerDollar={isBuyerBrokerDollar}
          setIsBuyerBrokerDollar={setIsBuyerBrokerDollar}
          isEditMode={true}
          isSidebarOpen={showModal}
        />
      )}
    </Modal>
  );
};

export default EditUnderContractModal;
